import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface ConfirmDialogData {
  id: string;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  type: 'danger' | 'warning' | 'info';
}

export interface ConfirmDialogResult {
  id: string;
  confirmed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  private dialogSubject = new Subject<ConfirmDialogData>();
  private resultSubject = new Subject<ConfirmDialogResult>();
  
  public dialog$ = this.dialogSubject.asObservable();
  public result$ = this.resultSubject.asObservable();

  confirm(
    title: string, 
    message: string, 
    confirmText: string = 'Confirm', 
    cancelText: string = 'Cancel',
    type: 'danger' | 'warning' | 'info' = 'warning'
  ): Promise<boolean> {
    const id = this.generateId();
    
    return new Promise((resolve) => {
      const subscription = this.result$.subscribe(result => {
        if (result.id === id) {
          resolve(result.confirmed);
          subscription.unsubscribe();
        }
      });

      this.dialogSubject.next({
        id,
        title,
        message,
        confirmText,
        cancelText,
        type
      });
    });
  }

  sendResult(id: string, confirmed: boolean): void {
    this.resultSubject.next({ id, confirmed });
  }

  private generateId(): string {
    return `dialog-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}
